export const fields = {
  Attendee: "is_waitlisted,person,attendee_type",
  AttendeeTypeSelection: "name,available_count,count,waitlist,attendee_type,signup_time,price",
  AttendeeType: "name,signup_time,constrained_capacity,position,waitlist",
  Event: "attendee_types,event_times,registration_type",
  EventTime: "name",
  Person: "name,avatar_url"
}

export const include = [
  "attendee_type_selections",
  "attendees",
  "attendees.person",
  "event",
  "event.attendee_types",
  "event.event_times",
  "responsible_person"
]
